import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { MessageFacade } from 'ish-core/facades/message.facade';
import { HttpError } from 'ish-core/models/http-error/http-error.model';

/**
 * The Error Message Component displays an error message for an {@link HttpError}.
 *
 * @example
   <ish-error-message [error]="error"></ish-error-message>
 */
@Component({
  selector: 'ish-error-message',
  templateUrl: './error-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ServerHtmlDirective, TranslateModule],
})
export class ErrorMessageComponent implements OnChanges {
  private messageFacade = inject(MessageFacade);

  readonly error = input.required<Partial<HttpError>>();
  readonly toast = input(true);

  ngOnChanges() {
    if (this.toast()) {
      this.displayToast(this.error());
    }
  }

  private displayToast(err: Partial<HttpError>) {
    if (err && !err.errors) {
      this.messageFacade.error({
        message: err.message || err.code,
      });
    }
    if (err?.errors) {
      err?.errors.map(cause => {
        this.messageFacade.error({
          message: cause.message,
        });
      });
    }
  }
}
